import styled from 'styled-components'
import { UserGroup } from '../../../models/UserGroup'
import { BlueButton, SelectedProps } from '../../Layout/CommonStyle'
import { useState } from 'react'
import { axiosPost } from '../../Common/Axios'
import toast from 'react-hot-toast'

type Props = {
  groups: UserGroup[]
  setGroups: (groups: UserGroup[]) => void
  selectedGroup: UserGroup | undefined
  setSelectedGroup: (group: UserGroup) => void
}

function JobClassList(props: Props) {
  const [insertMode, setInsertMode] = useState<boolean>(false)
  const [groupName, setGroupName] = useState<string>('')

  const handleInsertGroup = async () => {
    if (groupName === '') {
      alert('학급명을 입력하세요')
      return
    }

    // const payload = {
    //   id: '0',
    //   namea: groupName,
    // }

    const userGroup = {
      id: 0,
      name: groupName,
      createTime: null,
    }
    const result = await axiosPost('/api/user/group', userGroup)
    if (result === '') {
      toast.error('학급 추가에 실패했습니다.')
      return
    }

    toast.success('학급을 추가했습니다.')

    const group = result.data as UserGroup
    props.setGroups([...props.groups, group])
    props.setSelectedGroup(group)

    setInsertMode(false)
  }

  return (
    <Container>
      <Toolbar>
        <BlueButton onClick={() => setInsertMode(!insertMode)}>+</BlueButton>
        {insertMode && (
          <>
            <input
              type="text"
              placeholder="학급명"
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
            />
            <BlueButton onClick={() => handleInsertGroup()}>확인</BlueButton>
          </>
        )}
      </Toolbar>
      {props.groups.map((group: UserGroup, index: number) => (
        <Line
          key={index}
          selected={group === props.selectedGroup ? 'selected' : ''}
          onClick={() => props.setSelectedGroup(group)}
        >
          {group.name}
        </Line>
      ))}
    </Container>
  )
}

const Container = styled.div`
  grid-area: leftside;
`

const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 10px;
  margin-bottom: 10px;

  button {
    min-width: 40px;
    padding: 10px 10px;
    margin: 0;
    font-size: 0.9rem;
  }
  input[type='text'] {
    padding: 10px 10px;
    width: 80px;
  }
`
const Line = styled.div`
  padding: 0.5rem;
  cursor: pointer;

  background-color: ${(props: SelectedProps) =>
    props.selected === 'selected' ? 'orange' : 'white'};
`

export default JobClassList
